import { render, staticRenderFns } from "./bnChargeVentes.vue?vue&type=template&id=fac6a208&"
import script from "./bnChargeVentes.vue?vue&type=script&lang=js&"
export * from "./bnChargeVentes.vue?vue&type=script&lang=js&"
import style0 from "./bnChargeVentes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports